<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-12-30 20:40:32
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-12-30 22:17:47
-->
<template>
  <el-dialog width="480px" :visible.sync="dialogVisible" :append-to-body='true' show-close @close="resetForms()" :close-on-click-modal="false">
    <template slot="title">
      <p><span>编辑达人主页链接</span></p>
    </template>
    <div class="tips mb-20">
      系统根据主页链接获取并更新达人数据，若该达人与已有达人快手号/id相同则系统会自动合并数据，请确认链接无误后提交。
    </div>
    <el-form
      :inline="true"
      :model="formData"
      label-width="110px"
      ref="from"
      :rules="rules"
    >
      <el-form-item label="主页链接" prop="shot_link">
        <el-input v-model="formData.shot_link" placeholder="请录入达人主页链接" style="width: 315px;"></el-input>
        <p><a class="fz-14 link primary" href="https://chaoyongtuan.yuque.com/docs/share/3b423626-86d3-4670-83e5-24aad7cdb95e?#" target="_blank">如何获取达人主页链接？</a></p>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="submit">确认</el-button>
    </span>
  </el-dialog>
</template>
<script>
import throttle from 'lodash/throttle';
import { addKsLink } from '@/api/talentCRM'
export default {
  name: 'addJxHomeUrl',
  data() {
    return {
      dialogVisible: false,
      formData: {
        anchor_id: '',
        shot_link: '',
      },
      rules: {
        shot_link: [
          { required: true, message: '请输入达人的主页链接', trigger: 'blur' },
        ],
      }
    }
  },
  methods: {
    show(obj) {
      this.formData = {...obj};
      this.dialogVisible = true;
    },
    resetForms() {
      this.$refs['from'].resetFields();
    },
    submit: throttle(function() {
      this.$refs.from.validate(async valid => {
        if(!valid) return
        const { formData: {
          shot_link,
          anchor_id
        } } = this
        const { code } = await addKsLink({shot_link, anchor_id})
        if(code !== 0) return
        this.$message.success('达人主页链接添加成功')
        this.$emit('refresh')
        this.handleClose()
      });
    }, 1000),
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>
<style lang='less' scoped>
.tips{
    padding: 11px 16px;
    background-color: #E9F1FF;
    border: 1px solid #5091FF;
    border-radius: 5px;
}
</style>